<template>
    <SKModal
        ref="modal"
        :fullscreen="false"
        actionButtonsPosition="right"
        :hasAcceptButton="true"
        :accept-callback="save"
        :title="$t('admin.users.actions.change_email')"
    >
        <template v-slot:body>
            <vs-input
                :label="$t('apps.registered-users.email')"
                type="email"
                class="mt-4 w-full border-grey-light"
                v-model="email"
                :required="true"
            />
        </template>
    </SKModal>
</template>
<script>

import SKModal from "@/modules/Shared/Components/modal/SKModal";
import loader from "@/modules/Shared/Mixins/loader";
import UsersService from "@/modules/Apps/Services/UsersService";

export default {
    name: 'ChangeUserEmailModal',
    mixins: [loader],
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            email: '',
        }
    },
    components: {
        SKModal,
    },
    created() {
        this.email = this.user.email
    },
    methods: {
        async save() {
            await this.loadAndNotify(async () => {
                await UsersService.editUser(
                    this.$route.params.uuid,
                    this.user.uuid,
                    { email: this.email }
                )
                this.$emit('update')
            })
        },
        async open() {
            this.email = this.user.email
            this.$refs['modal'].open()
        },
    },
}
</script>
